module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_brows.9d0011eb.png";